import {Component, ChangeDetectionStrategy, input} from '@angular/core';

@Component({
    selector: 'app-preloader',
    templateUrl: './preloader.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class PreloaderComponent {
  readonly loadName = input<string>('Загрузка');
}
